/**
* Image Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'image-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.image-cards__card' ).on( 'mouseover', function() {
        $( this ).find( '.card-content' ).slideDown( 250 );
      } ).on( 'mouseout', function() {
        $( this ).find( '.card-content' ).slideUp( 250 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-cards', COMPONENT );
} )( app );
